module.exports = __webpack_public_path__ + "media/fr-2.13bd66bc.mp3";